export default "/images/chevron-up.svg?2623c7011facc4ceb916519d9983892d";